import React, { forwardRef, useEffect } from "react";
import DatePicker, { DateObject, DatePickerRef } from "react-multi-date-picker";
import "./datePicker.scss"; // Your custom styles
import "react-multi-date-picker/styles/layouts/mobile.css"; // Mobile-friendly layout
import moment from "moment";

// Define the interface for the props you want to pass:
export interface CustomDatePickerProps {
  render?: any;
  className?: string;
  datePickerContainerClassName?: string;
  monthYearSeparator?: string;
  inputMode?: string;
  themeColor?: string;
  closeBtnOnclick?: () => void;
  applyBtnOnclick?: () => void;
  handleOnChange?: (dates: any) => void;
  containerClassName?: string;
  arrowClassName?: string;
  offsetY?: number;
  selectedDates?: any;
  minDate?: Date | string | number | DateObject;
  maxDate?: Date | string | number | DateObject;
  format?: string;
  range?: boolean;
}
const shortMonths = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

// forwardRef will allow an optional ref to be passed. If none is provided, ref is undefined.
const CustomDatePicker = forwardRef<DatePickerRef, CustomDatePickerProps>((
  {
    render,
    className = "",
    datePickerContainerClassName = "",
    monthYearSeparator = " ",
    inputMode = "",
    themeColor = "red ",
    closeBtnOnclick,
    applyBtnOnclick,
    handleOnChange,
    containerClassName = "",
    arrowClassName = "",
    offsetY,
    selectedDates,
    maxDate = new Date(),
    minDate = "",
    format = "MMM DD YYYY",
    range = true,
  },
  ref
) => {
  return (
    <div className={containerClassName}>
      <DatePicker
        ref={ref as React.MutableRefObject<DatePickerRef>}
        arrowClassName={arrowClassName}
        value={selectedDates}
        containerClassName={datePickerContainerClassName}
        onChange={handleOnChange}
        minDate={minDate ? moment(minDate instanceof DateObject ? minDate.toDate() : minDate).startOf("day").toDate() : ""}
        maxDate={maxDate ? moment(maxDate instanceof DateObject ? maxDate.toDate() : maxDate).endOf("day").toDate() : ""}
        range={range}
        rangeHover
        sort
        inputMode={inputMode}
        offsetY={offsetY}
        render={render}
        format={format}
        monthYearSeparator={monthYearSeparator}
        numberOfMonths={2} // Display two months side by side
        className={`${themeColor} ${className}`}
        months={shortMonths}
      >
        <div className="datepicker-footer">
          <button
            type="button"
            className="datepicker-btn datepicker-cancel-btn"
            onClick={closeBtnOnclick}
          >
            Cancel
          </button>
          <button
            type="button"
            className="datepicker-btn datepicker-apply-btn"
            onClick={applyBtnOnclick}
          >
            Apply
          </button>
        </div>
      </DatePicker>
    </div>
  );
});


export default CustomDatePicker;
